import runtimeKeys from './runtimeKeys.json';

/** Settings that differ per environment, read from `config.js` at startup. */
export type RuntimeKey =
  | 'VITE_API_BASE_URL'
  | 'VITE_COGNITO_REGION'
  | 'VITE_COGNITO_USER_POOL_ID'
  | 'VITE_COGNITO_USER_POOL_WEB_CLIENT_ID'
  | 'VITE_OAUTH_TOKEN_ENDPOINT_URL'
  | 'VITE_TRIBE_ADMIN_BASE_URL'
  | 'VITE_TRIBE_ADMIN_PROGRAM_MANAGER'
  | 'VITE_S3_BUCKET_URI'
  | 'VITE_ENV';

export type AppEnv = Record<RuntimeKey, string>;

type SettingSource = Partial<Record<string, string | undefined>>;

declare global {
  interface Window {
    aslanConfig?: SettingSource;
  }
}

export const RUNTIME_KEYS = runtimeKeys.keys as RuntimeKey[];

/** A promotable build reads only `config.js`; dev servers and tests fall back to `.env`. */
export function resolveAppEnv(
  runtime: SettingSource | undefined,
  buildTime: SettingSource,
  required: boolean
): AppEnv {
  const resolved: Partial<AppEnv> = {};
  const missing: string[] = [];

  RUNTIME_KEYS.forEach((key) => {
    const value = runtime?.[key] ?? (required ? undefined : buildTime[key]);
    if (value === undefined) {
      missing.push(key);
    } else {
      resolved[key] = value;
    }
  });

  if (required && missing.length > 0) {
    throw new Error(
      `config.js is missing ${missing.join(
        ', '
      )}. These settings are written by Terraform (aws-infrastructure layer 9_cdn).`
    );
  }

  return resolved as AppEnv;
}

const RUNTIME_CONFIG_REQUIRED = import.meta.env.VITE_RUNTIME_CONFIG === 'required';

export const appEnv = resolveAppEnv(window.aslanConfig, import.meta.env, RUNTIME_CONFIG_REQUIRED);

export default appEnv;
